import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import FormTemplate from './FormTemplate'
import { isNullOrUndefined } from 'util'
import moment from 'moment'
import { DATE_FORMAT } from './../../utils/constants';

let ModalTemplate = (props) => {
    return (
        <Modal show={props.openModal} onHide={props.closeModal} dialogClassName={!isNullOrUndefined(props.className) && props.className}>
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isNullOrUndefined(props.name) && !isNullOrUndefined(props.uploadImageContainer) && props.uploadImageContainer()}
                {"renewal" === props.name && !isNullOrUndefined(props.details) &&
                    <div className="subscription-startdate">
                        <b>Subscription Start Date</b><br />
                        {(!isNullOrUndefined(props.details.subscriptionStartDate) &&  "" !== props.details.subscriptionStartDate)  ? moment(props.details.subscriptionStartDate).format(DATE_FORMAT) : "Not yet subscribed"}
                    </div>
                }
                <FormTemplate
                    formName="renewal"
                    formInputs={props.form}
                    bindSubmitFormik={props.bindSubmitFormik}
                    editorState={props.editorState}
                    updateEditorState={props.updateEditorState}
                    initialValues={props.initialValues}
                    updateFormRef={props.updateFormRef}
                    handleSubmit={props.handleSubmit}
                    validate={props.validate}
                    editMode={props.editMode}
                    readOnly={props.readOnly}
                />

                {"renewal" === props.name && !isNullOrUndefined(props.uploadImageContainer) && props.uploadImageContainer()}

            </Modal.Body>
            <Modal.Footer>
                <React.Fragment>
                    <div className="modal-buttons">
                        <div>
                            {props.renderButtons && props.renderButtons.map((button, i) => {
                                return <Button key={button.label + i} variant={button.variant} className="flex-align pull-right header-button" onClick={button.onClick}>{button.icon && (<button.icon style={{ marginTop: -4, marginRight: 6 }} />)}{button.label}</Button>
                            })}
                        </div>
                    </div>
                    <hr />
                </React.Fragment>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalTemplate